import React from 'react';
import { Card, Stack, Title, Group } from '@mantine/core';
import { BookingPaymentButton } from '../BookingPaymentButton';
import { CancelBookingButton } from '../CancelBookingButton';
import { BookingNote } from '../BookingNote';
import { AcceptButton } from '../AcceptButton';
import { DeclineBooking } from '../DeclineBooking';
import { BookingResponseModel } from '../../../../../types/BookingModels';


interface SingleBookingActionsCardProps {
  booking: BookingResponseModel;
  profileId: string;
  groupedBookings: BookingResponseModel[];
  bookingType: 'incoming' | 'outgoing';
  totalCost: number;
  isFinished: boolean;
  refreshBookings: () => void;
  token: string | undefined;
  reloadOnSuccess?: boolean;
}


export const SingleBookingActionsCard = ({
  booking,
  profileId,
  groupedBookings,
  bookingType,
  totalCost,
  isFinished,
  refreshBookings,
  token,
  reloadOnSuccess,
}: SingleBookingActionsCardProps) => {
  return (
    <Card maw={600} mx='auto' shadow='none' withBorder data-testid="single-booking-actions-card">
      <Stack>
        <Title order={5}>Actions & Updates</Title>

        <Group>
          <BookingPaymentButton
            booking={booking}
            profileId={profileId}
            groupedBookings={groupedBookings}
            reloadOnSuccess={reloadOnSuccess}
          />
          <AcceptButton
            groupedBookings={groupedBookings}
            profileId={profileId}
            refreshBookings={refreshBookings}
            token={token}
            reloadOnSuccess={reloadOnSuccess}
          />
          <DeclineBooking
            groupedBookings={groupedBookings}
            profileId={profileId}
            refreshBookings={refreshBookings}
            reloadOnSuccess={reloadOnSuccess}
          />
          <CancelBookingButton
            refreshBookings={refreshBookings}
            profileId={profileId}
            groupedBookings={groupedBookings}
            overrideText={'Cancel Conversation'}
            reloadOnSuccess={reloadOnSuccess}
          />
        </Group>

        {booking.isCancelled && booking.cancellationReason && (
          <BookingNote variant="cancellation" text={booking.cancellationReason} />
        )}

        {booking.paymentStatus !== 'succeeded' && booking.bookingFee > 0 && isFinished && (
          <BookingNote variant="no-payment" />
        )}

        {booking.paymentStatus === 'succeeded' && (
          <BookingNote variant="paid" text={`Payment successful £${totalCost?.toFixed(2)}`} />
        )}

        {booking.message && (
          <BookingNote variant="comment" text={booking.message} />
        )}
      </Stack>
    </Card>
  );
};
